import { Component, OnInit, ViewChild } from '@angular/core';
import { AppInformationService, ArkUnitOfWork, BreezeDxStoreService, CustomStore } from 'app/core/core.module';
import { Guid } from 'app/core/data/entities';
import { Family } from 'app/core/model/entity-model';
import { InputDialogComponent } from 'app/shared/input-dialog/input-dialog.component';
import { Predicate } from 'breeze-client';
import { FormsModule } from '@angular/forms';
import { DevExtremeModule, DxDataGridComponent } from 'devextreme-angular';
import { confirm } from 'devextreme/ui/dialog';
import { BsModalService } from 'ngx-bootstrap/modal';

@Component({
    selector: 'app-households',
    templateUrl: './households.component.html',
    styleUrls: ['./households.component.css'],
    imports: [DevExtremeModule, FormsModule],
    standalone: true,
})
export class HouseholdsComponent implements OnInit {
    households: any[];
    families: Family[];
    dialogFamilies: CustomStore;
    popupVisible = false;
    selectedHouseholdId: Guid;
    householdDialogVisible = false;

    @ViewChild('householdGrid') householdGrid: DxDataGridComponent;
    @ViewChild('householdFamiliesGrid') householdFamiliesGrid: DxDataGridComponent;
    @ViewChild('unselectedFamiliesGrid') unselectedFamiliesGrid: DxDataGridComponent;
    householdEdit: any;

    constructor(
        private uow: ArkUnitOfWork,
        private storeService: BreezeDxStoreService,
        private appInfo: AppInformationService,
        private modalService: BsModalService,
    ) {}

    ngOnInit() {
        this.getData();
    }

    async getData() {
        this.households = await this.uow.households.all('number', 'careCoordinator, families');
    }

    async getFamilies() {
        if (this.households) {
            // this.families = this.households.find((h) => h.id === this.selectedHouseholdId).families.filter((f) => f.includeInDirectory);
            const predicate = new Predicate('householdId', '==', this.selectedHouseholdId); //.and('includeInDirectory', '==', true);
            this.families = await this.uow.families.where(predicate, 'name');
        }
    }

    async editHousehold(key?: number) {
        if (!key) {
            this.householdEdit = this.uow.households.createEntity();
        } else {
            this.householdEdit = await this.householdGrid.instance.byKey(key);
        }
        this.householdDialogVisible = true;
    }

    householdDialogHidden(e) {
        this.uow.rollback();
    }

    getDialogPeopleStore() {
        const notSelected = new Predicate('householdId', '==', this.selectedHouseholdId).not();
        const query = this.uow.families.baseQuery().where(notSelected).where('includeInDirectory', '==', true).where('members', 'any', 'id', '>', 0);

        this.dialogFamilies = this.storeService.createStore(this.uow, this.uow.families, query, 'id');
    }

    async gridRowRemoved(e) {
        // console.log(e);
        // const entity: Entity = e.data;
        // if (entity.entityAspect.entityState === EntityState.Added) {
        //     entity.entityAspect.setDetached();
        // } else {
        //     entity.entityAspect.setDeleted();
        // }
        // await this.uow.commit();
    }

    async saveHousehold() {
        await this.uow.commit();
        this.getData();
        this.householdDialogVisible = false;
    }

    async onHouseholdSelectionChanged(e) {
        // this.selectedHouseholdId = e.currentSelectedRowKeys[0];
        this.selectedHouseholdId = this.householdGrid.focusedRowKey;
        if (this.selectedHouseholdId) {
            this.getFamilies();
        } else {
            this.families = null;
        }
    }

    addToHousehold() {
        this.getDialogPeopleStore();
        this.popupVisible = true;
    }

    async removeFromHousehold() {
        const dialogResult = await (<Promise<boolean>>confirm('Are you sure you want to remove these people from the household?', 'Remove from Household'));
        if (!dialogResult) return;

        const selectedFamilies = await this.householdFamiliesGrid.instance.getSelectedRowsData();
        selectedFamilies.forEach((family) => {
            family.householdId = null;
        });
        await this.uow.commit();
        this.householdFamiliesGrid.instance.clearSelection();
        // this.householdFamiliesGrid.instance.refresh();
        this.getFamilies();
    }

    async addSelectedFamilies() {
        this.popupVisible = false;
        const selectedFamilies = await this.unselectedFamiliesGrid.instance.getSelectedRowsData();
        this.unselectedFamiliesGrid.instance.clearSelection();
        selectedFamilies.forEach((family) => {
            family.householdId = this.selectedHouseholdId;
        });
        await this.uow.commit();
        this.getFamilies();
        // this.householdFamiliesGrid.instance.refresh();
    }

    onToolbarPreparing(e) {
        e.toolbarOptions.items.unshift({
            location: 'before',
            template: 'toolbarButtons',
        });
    }

    onDialogToolbarPreparing(e) {
        e.toolbarOptions.items.unshift({
            location: 'before',
            template: 'dialogButtons',
        });
    }

    async addPerson(mode: 'Elder' | 'Deacon' | 'CareCoordinator') {
        const people = (await this.uow.people.all()).map((x) => {
            return {
                id: x.id,
                name: `${x.firstName} ${x.lastName}`,
            };
        });

        const modalRef = this.modalService.show(InputDialogComponent, {
            class: 'modal-sm',
            ignoreBackdropClick: true,
            keyboard: false,
            initialState: {
                dialogHeader: `Add ${mode}`,
                dialogPrompt: 'Select Person',
                dialogValueArray: people,
                mode: 'selectWithId',
            },
        });

        modalRef.content.result.subscribe(async (result) => {
            if (result.success) {
                const selectedRow = await this.householdGrid.instance.byKey(this.householdGrid.focusedRowKey);
                console.log(selectedRow);
                selectedRow[mode === 'Elder' ? 'elderId' : mode === 'Deacon' ? 'deaconId' : 'careCoordinatorId'] = result.value;
                await this.uow.commit();
                await this.getData();
            }
            modalRef.hide();
        });
    }
}
